export default __webpack_public_path__ + "Inter-Italic.var.woff2";